import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Report from "@/pages/Report";
import Database from "@/pages/Database";
import Recovery from "@/pages/Recovery";
import RiskChecker from "@/pages/RiskChecker";
import RedFlags from "@/pages/RedFlags";
import Education from "@/pages/Education";
import Stories from "@/pages/Stories";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LossCategory from "@/pages/LossCategory";
import ScammerDetail from "@/pages/ScammerDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Mentors from "@/pages/Mentors";
import MentorDetail from "@/pages/MentorDetail";
import Blog from "@/pages/Blog";
import Admin from "@/pages/Admin";
import AdminRoute from "@/components/AdminRoute";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";

const AppRouter = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/loss/:categoryKey" element={<LossCategory />} />
        <Route path="/report" element={<Report />} />
        <Route path="/database" element={<Database />} />
        <Route path="/database/:id" element={<ScammerDetail />} />
        <Route path="/recovery" element={<Recovery />} />
        <Route path="/risk-checker" element={<RiskChecker />} />
        <Route path="/red-flags" element={<RedFlags />} />
        <Route path="/education" element={<Education />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/legal-help" element={<Navigate to="/loss/other" replace />} />
        <Route path="/mentors" element={<Mentors />} />
        <Route path="/mentors/:slug" element={<MentorDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
